module.exports = __webpack_public_path__ + "static/media/footer-logo.551a7a9c.png";